import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Display from "../../../Elements/Display/Display";
import anime from "animejs";

const BalanceCounter = ({ value }) => {
  // Declare a state variable 'balance' initialized with the 'value' prop
  const [balance, setBalance] = useState(value);

  // Create a ref to attach to the DOM element for animation purposes
  const displayRef = useRef(null);

  // Use the useSelector hook to access 'currentRound' and 'counterAnimationFinished' state from Redux
  const { currentRound } = useSelector((state) => state.game); // ✅ Use `currentRound`
  const { counterAnimationFinished } = useSelector((state) => state.spin);

  // useEffect hook to perform side effects based on changes in `currentRound.win`, `counterAnimationFinished`, and `value`
  useEffect(() => {
    // Check if there is a win and the counter animation has finished
    if (currentRound?.win > 0 && counterAnimationFinished) {
      // If the displayRef is attached to a DOM element, perform an animation
      if (displayRef.current) {
        anime({
          targets: displayRef.current, // Target the DOM element
          scale: [1, 1.15, 1], // Define the scale animation
          duration: 500, // Animation duration in milliseconds
          easing: "easeInOutSine", // Easing function for the animation
        });
      }
      // Update the balance state to the new value
      setBalance(value);
    } else if (currentRound?.win === 0) {
      // If there is no win, simply update the balance to the new value
      setBalance(value);
    }
  }, [currentRound, counterAnimationFinished, value]); // ✅ Updated dependencies

  // Render the component
  return (
    // Attach the ref to the div element for animation
    <div ref={displayRef}>
      {/* Render the Display component with the current balance */}
      <Display label="balance" value={balance} modifier="displayBalance" />
    </div>
  );
};

export default BalanceCounter;
